import React from 'react';
import { SectionReveal } from './ui/SectionReveal';
import { ArrowRight } from 'lucide-react';
export function Insights() {
  const articles = [{
    title: 'DORA Metrics in Practice: Beyond the Dashboard',
    category: 'Engineering Metrics',
    readTime: '6 min read'
  }, {
    title: 'How to Restructure Your Engineering Org for Series B',
    category: 'Org Design',
    readTime: '8 min read'
  }, {
    title: 'The Hidden Cost of Slow PR Reviews (And How to Fix It)',
    category: 'Developer Productivity',
    readTime: '5 min read'
  }];
  return <section id="insights" className="py-24 md:py-32" data-id="element-157">
      <div className="container mx-auto px-6 md:px-12" data-id="element-158">
        <SectionReveal data-id="element-159">
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16" data-id="element-160">
            <div className="max-w-2xl" data-id="element-161">
              <h2 className="font-serif text-4xl md:text-5xl mb-6" data-id="element-162">
                Insights & Writing
              </h2>
              <p className="text-lg text-secondary" data-id="element-163">
                Thoughts on engineering leadership, developer productivity, and
                scaling teams.
              </p>
            </div>
            <a href="#" className="inline-flex items-center text-sm font-medium text-accent hover:text-accent-hover transition-colors group" data-id="element-164">
              View all articles
              <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-165" />
            </a>
          </div>
        </SectionReveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-166">
          {articles.map((article, index) => <SectionReveal key={index} delay={index * 0.1} data-id="element-167">
              <a href="#" className="block group" data-id="element-168">
                <div className="p-8 rounded-2xl bg-surface border border-border group-hover:border-accent/30 transition-colors h-full flex flex-col" data-id="element-169">
                  <div className="flex items-center gap-3 text-xs text-muted uppercase tracking-wider mb-4" data-id="element-170">
                    <span data-id="element-171">{article.category}</span>
                    <span data-id="element-172">•</span>
                    <span data-id="element-173">{article.readTime}</span>
                  </div>
                  <h3 className="text-xl font-medium mb-4 group-hover:text-accent transition-colors" data-id="element-174">
                    {article.title}
                  </h3>
                  <div className="mt-auto pt-6" data-id="element-175">
                    <span className="text-sm text-secondary flex items-center group-hover:text-primary transition-colors" data-id="element-176">
                      Read article{' '}
                      <ArrowRight className="ml-2 w-4 h-4 opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all" data-id="element-177" />
                    </span>
                  </div>
                </div>
              </a>
            </SectionReveal>)}
        </div>
      </div>
    </section>;
}